// vernaticsModal.js
import { createModal } from './modal.js';
import tippy from 'tippy.js';
import { createIcons, icons } from 'lucide';

export function createVernaticsModal({ currLang, validateAddress }) {
  // ---- build the persistent DOM tree once -------------------------------
  const wrapper = document.createElement('div');
  wrapper.className = 'vernatics-modal';
  wrapper.style.display = 'flex';

  wrapper.innerHTML = `
    <div class="vernatics-modal__screen vernatics-modal__screen--1">
      <button class="button" id="connect-board" style="margin:0.5rem">
        <span class="control-btn">${currLang['ConnectToBoard']} <i data-lucide="signal-high"></i></span>
      </button>
      <button class="button" id="instruction-wifi" style="margin:0.5rem">
        <span class="control-btn">${currLang['ConfigureWifi']} <i data-lucide="wifi"></i></span>
      </button>
    </div>

    <div class="vernatics-modal__screen vernatics-modal__screen--2" style="display:none;">
      <button class="back-btn-translate"><i data-lucide="arrow-big-left"></i></button>
      <div>
        <b class="ip-label" style="margin:0.5rem">${currLang['ShareFeature.IpAddressLabel']}</b><br>
        <input type="text" id="input-ip" placeholder="${currLang['ShareFeature.IpAddressPlaceholder']}" style="margin:0.5rem"><br>
        <label class="filename-label" style="margin:0.5rem;display:none;">${currLang['ShareFeature.FileNameLabel']}</label>
        <span id="device-controls" class="container">
          <input type="text" id="input-filename" placeholder="test.py">
          <button class="button" id="send-code"><i data-lucide="square-play"></i></button>
          <button class="button" id="stop-code"><i data-lucide="rotate-ccw"></i></button>
        </span><br>
      </div>
      <button class="button" id="establish-connection" style="margin:0.5rem">
        <span class="control-btn">${currLang['ShareFeature.Connect']} <i data-lucide="signal-high"></i></span>
      </button>
      <span class="control-btn" id="connection-status" style="margin:0.5rem;text-align:center;">${currLang['ShareFeature.NotConnected']}</span>
      <button class="button" id="done-button" style="margin:0.5rem">
        <span class="control-btn">${currLang['ShareFeature.Done']}</span>
      </button>
    </div>

    <div class="vernatics-modal__screen vernatics-modal__screen--3" style="display:none;max-height:50vh;">
      <button class="back-btn-translate"><i data-lucide="arrow-big-left"></i></button>
      <button class="instruct-btn-translate"><i data-lucide="info"></i></button>
      <div class="scrollable-content">
        <div class="steps-container">
          <h4>${currLang['ShareFeature.HotspotSetupGuide']}</h4>
          <div class="step">
            <div class="step-content">
              <input type="text" id="input-device-ip" placeholder="${currLang['ShareFeature.DeviceIpPlaceholder']}" style="margin:0.5rem;width:80%;max-width:15rem;text-align:center;background-color:white;">
              <button class="button" id="configure-wifi" style="margin:0.5rem;width:80%;max-width:15rem">
                <span class="control-btn">${currLang['ShareFeature.ChangeWifiSettings']} <i data-lucide="wifi"></i></span>
              </button>
            </div>
          </div>
          <div class="instructions-steps">
            <h4>${currLang['ShareFeature.StepsToConfigureTheBoard']}</h4>
            <div class="step">
              <div class="step-number">1</div>
              <div class="step-content">
                <h5>${currLang['ShareFeature.EnterPairingMode']}</h5>
                <ol type="a">
                  <li>${currLang['ShareFeature.EnterPairingModeStepA']}</li>
                  <li>${currLang['ShareFeature.EnterPairingModeStepB']}</li>
                </ol>
              </div>
            </div>
            <div class="step">
              <div class="step-number">2</div>
              <div class="step-content">
                <h5>${currLang['ShareFeature.ConnectToHotspot']}</h5>
                <ol type="a">
                  <li>${currLang['ShareFeature.ConnectToHotspotStepA']}</li>
                  <li>${currLang['ShareFeature.ConnectToHotspotStepB']}</li>
                  <li>${currLang['ShareFeature.ConnectToHotspotStepC']}</li>
                </ol>
              </div>
            </div>
            <div class="step">
              <div class="step-number">3</div>
              <div class="step-content">
                <h5>${currLang['ShareFeature.SelectLocalNetwork']}</h5>
                <ol type="a">
                  <li>${currLang['ShareFeature.SelectLocalNetworkStepA']}</li>
                  <li>${currLang['ShareFeature.SelectLocalNetworkStepB']}</li>
                  <li>${currLang['ShareFeature.SelectLocalNetworkStepC']}</li>
                  <li>${currLang['ShareFeature.SelectLocalNetworkStepD']}</li>
                </ol>
              </div>
            </div>
            <div class="step">
              <div class="step-number">4</div>
              <div class="step-content">
                <h5>${currLang['ShareFeature.ConnectToLocalNetwork']}</h5>
                <ol type="a">
                  <li>${currLang['ShareFeature.ConnectToLocalNetworkStepA']}</li>
                  <li>${currLang['ShareFeature.ConnectToLocalNetworkStepB']}</li>
                </ol>
              </div>
            </div>
            <div class="step">
              <div class="step-number">5</div>
              <div class="step-content">
                <h5>${currLang['ShareFeature.ReconnectYourComputer']}</h5>
                <ol type="a">
                  <li>${currLang['ShareFeature.ReconnectYourComputerStepA']}</li>
                  <li>${currLang['ShareFeature.ReconnectYourComputerStepB']}</li>
                  <li>${currLang['ShareFeature.ReconnectYourComputerStepC']}</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
  document.body.appendChild(wrapper);

  const wifiWrapper = document.createElement('div');
  wifiWrapper.className = 'vernatics-wifi-modal';
  wifiWrapper.style.display = 'none';
  wifiWrapper.innerHTML = `
    <div class="step-iframe"></div>
    <button class="button" id="connect-board2">
      <span class="control-btn">${currLang['ConnectToBoard']} <i data-lucide="signal-high"></i></span>
    </button>
  `;
  document.body.appendChild(wifiWrapper);

  createIcons({ icons }); // renders every data-lucide="..." currently in the document

  // ---- modal instances ----------------------------------------------------
  const wifiModal = createModal({
    title: currLang['ConfigureWifi'],
    closable: true,
    size: 'md',
    content: () => wifiWrapper,
  });

  const mainModal = createModal({
    title: () => currLang['CodeButton.Text'] ?? 'Vernatics',
    closable: true,
    size: 'lg',
    content: () => wrapper,
    onOpen: () => showScreen(1),
  });
  mainModal.setClosable(false);
  // ---- scoped element handles ---------------------------------------------
  const screen1 = wrapper.querySelector('.vernatics-modal__screen--1');
  const screen2 = wrapper.querySelector('.vernatics-modal__screen--2');
  const screen3 = wrapper.querySelector('.vernatics-modal__screen--3');
  const backBtns = wrapper.querySelectorAll('.back-btn-translate');
  const instructBtn = wrapper.querySelector('.instruct-btn-translate');
  const doneBtn = wrapper.querySelector('#done-button'); // FIX: was undeclared before
  const inputFilename = wrapper.querySelector('#input-filename');
  const connectBoardBtn = wrapper.querySelector('#connect-board');
  const instructionWifiBtn = wrapper.querySelector('#instruction-wifi');
  const configureBtn = wrapper.querySelector('#configure-wifi');
  const connectionStatus = wrapper.querySelector('#connection-status');
  const inputIp = wrapper.querySelector('#input-ip');
  const connectBoardBtn2 = wifiWrapper.querySelector('#connect-board2');

  function showScreen(n) {
    screen1.style.display = n === 1 ? 'flex' : 'none';
    screen2.style.display = n === 2 ? 'flex' : 'none';
    screen3.style.display = n === 3 ? 'flex' : 'none';
  }

  const toggleTranslateEls = () => {
    wrapper.querySelector('#device-controls').style.display = 'inline-flex';
    wrapper.querySelector('.filename-label').style.display = 'block';
    wrapper.querySelector('.ip-label').textContent = currLang['ShareFeature.SaveCodeToDevice'];
    inputIp.style.display = 'none';
    connectionStatus.textContent = '';
  };

  const establishConnectionFunc = async (firstCall = null) => {
    let errMsg = currLang['Game.ErrorText'] + ' 😖';
    if (firstCall) errMsg = currLang['ShareFeature.NotConnected'];
    try {
      const fetchAddress = validateAddress();
      if (!fetchAddress) {
        alert(currLang['UI.FieldsCantBeEmpty']);
        return;
      }
      connectionStatus.textContent = currLang['ShareFeature.Connecting'];
      const response = await fetch(`${fetchAddress}/establish-connection`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ip: inputIp.value }),
      });
      const res = await response.json();
      if (res?.connected === true) {
        connectionStatus.textContent = currLang['ShareFeature.Connected'];
        doneBtn.style.display = 'flex';
        wrapper.querySelector('.back-btn-translate').style.display = 'none';
        inputIp.setAttribute('disabled', 'disabled');
        wrapper.querySelector('#establish-connection').style.display = 'none';
        mainModal.setClosable(true); // NEW — user can now close it
        return true;
      }
      connectionStatus.textContent = errMsg;
    } catch (err) {
      console.log(err);
      connectionStatus.textContent = errMsg;
    }
    return false;
  };

  const checkIpFunc = async (el) => {
    const checkIpStored = localStorage.getItem('savedIp');
    el.value = JSON.parse(checkIpStored);
    const isConnected = await establishConnectionFunc(true);
    if (isConnected) {
      showScreen(2);
      mainModal.close();
      toggleTranslateEls();
    }
  };

  // ---- wire up events (scoped, once) ---------------------------------------
  connectBoardBtn.addEventListener('click', () => showScreen(2));

  instructionWifiBtn.addEventListener('click', () => showScreen(3));

  backBtns.forEach((btn) => btn.addEventListener('click', () => showScreen(1)));

  instructBtn.addEventListener('click', () => {
    const instructEl = wrapper.querySelector('.instructions-steps');
    if (instructEl.style.maxHeight) {
      instructEl.style.maxHeight = null;
      instructEl.style.padding = '0 10px';
    } else {
      instructEl.style.maxHeight = instructEl.scrollHeight + 100 + 'px';
      instructEl.style.padding = '10px';
    }
  });

  wrapper
    .querySelector('#establish-connection')
    .addEventListener('click', () => establishConnectionFunc());

  doneBtn.addEventListener('click', () => {
    mainModal.close();
    toggleTranslateEls();
  });

  configureBtn.addEventListener('click', () => {
    const ipValueWifi = wrapper.querySelector('#input-device-ip').value;
    if (ipValueWifi.length === 0) {
      alert(currLang['UI.IpCantBeEmpty']);
      return;
    }
    wifiModal.open();
    wifiWrapper.querySelector('.step-iframe').innerHTML =
      `<iframe src="https://${ipValueWifi}:8000" title="description" style="height:90%;width:100%"></iframe>`;
  });

  connectBoardBtn2.addEventListener('click', () => {
    wifiModal.close();
    showScreen(2);
  });

  inputIp.addEventListener('change', () => {
    if (inputIp.value) localStorage.setItem('savedIp', JSON.stringify(inputIp.value));
  });

  inputFilename.addEventListener('change', () => {
    if (inputFilename.value)
      localStorage.setItem('savedFilename', JSON.stringify(inputFilename.value));
  });

  wrapper.querySelector('#send-code').addEventListener('click', async () => {
    try {
      const fetchAddress = validateAddress();
      if (!fetchAddress || inputFilename.value.length === 0) {
        alert(currLang['UI.FieldsCantBeEmpty']);
        return;
      }
      const code = document.getElementById('code-container'); // NOTE: see caveat below
      connectionStatus.textContent = currLang['UI.CodeBeingExecuted'];
      const responseUpload = await fetch(`${fetchAddress}/upload`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pythonCode: code.value, name: inputFilename.value }),
      });
      const res = await responseUpload.json();
      if (res.stat) {
        const responseRun = await fetch(`${fetchAddress}/run`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ file: inputFilename.value }),
        });
        const res2 = await responseRun.json();
        document.querySelector('#visualisation').innerText = res2.value;
        connectionStatus.textContent = currLang['UI.ExecutionSuccessful'];
      }
    } catch (err) {
      console.log(err);
    }
  });

  wrapper.querySelector('#stop-code').addEventListener('click', async () => {
    try {
      const fetchAddress = validateAddress();
      if (!fetchAddress) {
        alert(currLang['UI.FieldsCantBeEmpty']);
        return;
      }
      connectionStatus.textContent = currLang['UI.StoppingExecution'];
      const response = await fetch(`${fetchAddress}/stop`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ file: inputFilename.value }),
      });
      const res = await response.json();
      if (res.stat === true || res.stat === false) {
        document.querySelector('#visualisation').innerText = '';
        connectionStatus.textContent = currLang['UI.ExecutionStopped'];
      }
    } catch (err) {
      console.log(err);
    }
  });

  tippy('#send-code', {
    content: currLang['UI.ExecuteCodeTooltip'],
    placement: 'top',
    zIndex: 99999999999,
  });
  tippy('#stop-code', {
    content: currLang['UI.StopExecutionTooltip'],
    placement: 'top',
    zIndex: 99999999999,
  });

  const checkFilenameSaved = localStorage.getItem('savedFilename');
  if (checkFilenameSaved) inputFilename.value = JSON.parse(checkFilenameSaved);

  // ---- run the "auto reconnect" check NOW, since DOM is already ready -----
  // (FIX: old code waited for DOMContentLoaded, which had usually already
  // fired by the time this setup function ran — so it silently never fired)
  const vernaticsRoute = JSON.parse(sessionStorage.getItem('vernaticsAuth'));
  if (vernaticsRoute) {
    sessionStorage.setItem('vernaticsAuth', false);
  } else if (localStorage.getItem('savedIp')) {
    checkIpFunc(inputIp);
  }

  return mainModal;
}
